/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthBaseService } from '../auth-base-service';
import { AuthApiConfiguration } from '../auth-api-configuration';
import { AuthStrictHttpResponse } from '../auth-strict-http-response';

import { userGet } from '../fn/user/user-get';
import { UserGet$Params } from '../fn/user/user-get';
import { userGetUserOrganizationsGet } from '../fn/user/user-get-user-organizations-get';
import { UserGetUserOrganizationsGet$Params } from '../fn/user/user-get-user-organizations-get';
import { UserIdentityModel } from '../models/user-identity-model';
import { userIdGet } from '../fn/user/user-id-get';
import { UserIdGet$Params } from '../fn/user/user-id-get';
import { userPost } from '../fn/user/user-post';
import { UserPost$Params } from '../fn/user/user-post';
import { UserSearchResultModelSearchResultModel } from '../models/user-search-result-model-search-result-model';
import { userSearchUserPost } from '../fn/user/user-search-user-post';
import { UserSearchUserPost$Params } from '../fn/user/user-search-user-post';
import { userSetDefaultLanuagePost } from '../fn/user/user-set-default-lanuage-post';
import { UserSetDefaultLanuagePost$Params } from '../fn/user/user-set-default-lanuage-post';
import { userSetUserPractionerIdPost } from '../fn/user/user-set-user-practioner-id-post';
import { UserSetUserPractionerIdPost$Params } from '../fn/user/user-set-user-practioner-id-post';
import { userUserOrganizationsGet } from '../fn/user/user-user-organizations-get';
import { UserUserOrganizationsGet$Params } from '../fn/user/user-user-organizations-get';

@Injectable({ providedIn: 'root' })
export class AuthUserService extends AuthBaseService {
  constructor(config: AuthApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userSearchUserPost()` */
  static readonly UserSearchUserPostPath = '/User/SearchUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSearchUserPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userSearchUserPost$Response(params?: UserSearchUserPost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<UserSearchResultModelSearchResultModel>> {
    return userSearchUserPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSearchUserPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userSearchUserPost(params?: UserSearchUserPost$Params, context?: HttpContext): Observable<UserSearchResultModelSearchResultModel> {
    return this.userSearchUserPost$Response(params, context).pipe(
      map((r: AuthStrictHttpResponse<UserSearchResultModelSearchResultModel>): UserSearchResultModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `userIdGet()` */
  static readonly UserIdGetPath = '/User/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  userIdGet$Response(params: UserIdGet$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<UserIdentityModel>> {
    return userIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userIdGet(params: UserIdGet$Params, context?: HttpContext): Observable<UserIdentityModel> {
    return this.userIdGet$Response(params, context).pipe(
      map((r: AuthStrictHttpResponse<UserIdentityModel>): UserIdentityModel => r.body)
    );
  }

  /** Path part for operation `userGet()` */
  static readonly UserGetPath = '/User';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGet$Response(params?: UserGet$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<UserIdentityModel>> {
    return userGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGet(params?: UserGet$Params, context?: HttpContext): Observable<UserIdentityModel> {
    return this.userGet$Response(params, context).pipe(
      map((r: AuthStrictHttpResponse<UserIdentityModel>): UserIdentityModel => r.body)
    );
  }

  /** Path part for operation `userPost()` */
  static readonly UserPostPath = '/User';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userPost$Response(params?: UserPost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<string>> {
    return userPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userPost(params?: UserPost$Params, context?: HttpContext): Observable<string> {
    return this.userPost$Response(params, context).pipe(
      map((r: AuthStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `userSetDefaultLanuagePost()` */
  static readonly UserSetDefaultLanuagePostPath = '/User/SetDefaultLanuage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSetDefaultLanuagePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userSetDefaultLanuagePost$Response(params?: UserSetDefaultLanuagePost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<void>> {
    return userSetDefaultLanuagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSetDefaultLanuagePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userSetDefaultLanuagePost(params?: UserSetDefaultLanuagePost$Params, context?: HttpContext): Observable<void> {
    return this.userSetDefaultLanuagePost$Response(params, context).pipe(
      map((r: AuthStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userGetUserOrganizationsGet()` */
  static readonly UserGetUserOrganizationsGetPath = '/User/GetUserOrganizations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userGetUserOrganizationsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGetUserOrganizationsGet$Response(params?: UserGetUserOrganizationsGet$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<Array<string>>> {
    return userGetUserOrganizationsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userGetUserOrganizationsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGetUserOrganizationsGet(params?: UserGetUserOrganizationsGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.userGetUserOrganizationsGet$Response(params, context).pipe(
      map((r: AuthStrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `userUserOrganizationsGet()` */
  static readonly UserUserOrganizationsGetPath = '/User/UserOrganizations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userUserOrganizationsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  userUserOrganizationsGet$Response(params?: UserUserOrganizationsGet$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<Array<string>>> {
    return userUserOrganizationsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userUserOrganizationsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userUserOrganizationsGet(params?: UserUserOrganizationsGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.userUserOrganizationsGet$Response(params, context).pipe(
      map((r: AuthStrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `userSetUserPractionerIdPost()` */
  static readonly UserSetUserPractionerIdPostPath = '/User/SetUserPractionerId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSetUserPractionerIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userSetUserPractionerIdPost$Response(params?: UserSetUserPractionerIdPost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<void>> {
    return userSetUserPractionerIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSetUserPractionerIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userSetUserPractionerIdPost(params?: UserSetUserPractionerIdPost$Params, context?: HttpContext): Observable<void> {
    return this.userSetUserPractionerIdPost$Response(params, context).pipe(
      map((r: AuthStrictHttpResponse<void>): void => r.body)
    );
  }

}
